export const AnimationList = {
  Walking: require("../animations/Walking.fbx"),
  Running: require("../animations/Running.fbx"),
  Macarena: require("../animations/macarena.fbx"),
  Chicken: require("../animations/chicken.fbx"),
  HipHop: require("../animations/hiphop.fbx"),
  Rumba: require("../animations/rumba.fbx"),
  Female_Dance_Pose: require("../animations/Female Dance Pose.fbx"),
  Flair: require("../animations/Female Dance Pose.fbx"),
  Hanging_Idle: require("../animations/Female Dance Pose.fbx"),
  Standing_Clap: require("../animations/Standing Clap.fbx"),
  Start_Plank: require("../animations/Start Plank.fbx"),
  Taunt: require("../animations/Taunt.fbx"),
  Walk_With_Rifle: require("../animations/Walk With Rifle.fbx"),
};


export const AnimationListExtended = [
  // {name:'Walking', animation:AnimationList.Walking},
  // {name:'Running', animation:AnimationList.Running},
  {name:'Macarena', animation:AnimationList.Macarena},
  {name:'Chicken', animation:AnimationList.Chicken},
  {name:'HipHop', animation:AnimationList.HipHop},
  // {name:'Rumba', animation:AnimationList.Rumba},
  // {name:'Dance Pose', animation:AnimationList.Female_Dance_Pose},
  // {name:'Flair', animation:AnimationList.Flair},
  // {name:'Hanging Idle', animation:AnimationList.Hanging_Idle},
  {name:'Standing Clap', animation:AnimationList.Standing_Clap},
  {name:'Start Plank', animation:AnimationList.Start_Plank},
  // {name:'Taunt', animation:AnimationList.Taunt},
  // {name:'Walk with fifle', animation:AnimationList.Walk_With_Rifle},
];